import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { signIn } from "../firebase/auth";
import { USE_REAL_FIREBASE } from "../firebase/config";

const standardLogoSrc = `${process.env.PUBLIC_URL}/InvestX - Standard Logo.png`;
const horizontalLogoSrc = `${process.env.PUBLIC_URL}/${encodeURIComponent("InvestX - Horizontal transparent.png")}`;

const LoginScreen = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { setMockUser } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const result = await signIn(email.trim(), password);

      if (!result.success) {
        setError(result.error || "Failed to login. Please check your credentials.");
        return;
      }

      if (!USE_REAL_FIREBASE) {
        setMockUser(result.user);
      }

      navigate("/");
    } catch (err) {
      setError("Failed to login. Please check your credentials.");
      console.error("Login error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSkipLogin = () => {
    setMockUser({
      uid: "test-user-123",
      email: "test@example.com",
      displayName: "Test User",
    });
    navigate("/");
  };

  return (
    <div
      className="screen"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: 18 }}>
        <img
          src={standardLogoSrc}
          alt="InvestX standard logo"
          style={{
            width: 170,
            height: 68,
            objectFit: "contain",
            display: "block",
            margin: "0 auto 10px",
          }}
        />
        <img
          src={horizontalLogoSrc}
          alt="InvestX horizontal logo"
          style={{
            width: 230,
            height: 72,
            objectFit: "contain",
            display: "block",
            margin: "0 auto",
          }}
        />
      </div>
      <div className="login-header" style={{ textAlign: "center", marginTop: 48 }}>
        <h1 className="screen-title">Welcome Back</h1>
        <p className="screen-subtitle" style={{ marginBottom: 40 }}>
          Sign in to your investment portfolio
        </p>
      </div>
      <div className="form-container" style={{ maxWidth: 440, width: "100%" }}>
        {error && (
          <div
            style={{
              color: "#ff6b6b",
              background: "rgba(255, 107, 107, 0.1)",
              padding: "10px",
              borderRadius: "8px",
              marginBottom: "20px",
            }}
          >
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              autoComplete="email"
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              autoComplete="current-password"
            />
          </div>
          <button
            type="submit"
            className="btn btn-large w-full"
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <div className="text-center mt-3" style={{ marginBottom: 2 }}>
          <p style={{ color: "#94A3B8" }}>
            Don&apos;t have an account?{" "}
            <Link to="/register" style={{ color: "#3B82F6", textDecoration: "none" }}>
              Sign up
            </Link>
          </p>
        </div>
        {!USE_REAL_FIREBASE && (
          <div className="mt-3 text-center">
            <button
              type="button"
              onClick={handleSkipLogin}
              className="btn btn-outline btn-small"
              style={{ marginTop: "8px" }}
              disabled={loading}
            >
              DEV: Skip Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginScreen;
